import { Directive, Input, HostListener } from '@angular/core';

@Directive({
	selector: '[sm-only-numbers]'
})
export class SmOnlyNumbersDirective {
	@Input() href: string;

	constructor() { }

	@HostListener('keydown', ['$event'])
	onClick(e: any) {
		if (!((e.keyCode > 95 && e.keyCode < 106)
			|| (e.keyCode > 47 && e.keyCode < 58)
			|| e.keyCode == 8)) {
			return false;
		}
	}
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./app/shared/directives/sm-only-numbers.directive.ts